import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SHOW_PER_COURSE_REMINDER_SETTINGS } from '../constants/studentReminderPreferences';
import { NotificationIcon } from '../utils/icons';

type Props = {
  className?: string;
  courseId?: string;
  isMobile?: boolean;
  iconSize?: number;
};

const sanitizeReturnTo = (raw: string | null): string => {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) {
    return '/';
  }
  return raw;
};

const NotificationPreferencesButton: React.FC<Props> = ({
  className = '',
  courseId,
  isMobile = false,
  iconSize = 24,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId: routeCourseId } = useParams<{ courseId?: string }>();
  const effectiveCourseId = courseId ?? routeCourseId;

  const handleClick = () => {
    const returnTo = sanitizeReturnTo(location.pathname + location.search);
    const params = new URLSearchParams({ returnTo });
    if (SHOW_PER_COURSE_REMINDER_SETTINGS && effectiveCourseId) {
      params.set('courseId', effectiveCourseId);
    }
    navigate(`/notifications?${params.toString()}`);
  };

  const iconColor = isMobile ? '#fff' : undefined;

  return (
    <Tooltip title={t('reminderEmails.notificationsTooltip')} placement="bottom">
      <IconButton
        className={className}
        onClick={handleClick}
        aria-label={t('reminderEmails.notificationsTooltip')}
      >
        <NotificationIcon size={iconSize} color={iconColor} />
      </IconButton>
    </Tooltip>
  );
};

export default NotificationPreferencesButton;
